(function () {
  "use strict";

  var t = {
    580: function _(t, e, r) {
      var _o,
          n = this && this.__extends || (_o = function o(t, e) {
        return _o = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }
        }, _o(t, e);
      }, function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

        function r() {
          this.constructor = t;
        }

        _o(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }),
          a = this && this.__assign || function () {
        return a = Object.assign || function (t) {
          for (var e, r = 1, o = arguments.length; r < o; r++) {
            for (var n in e = arguments[r]) {
              Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }
          }

          return t;
        }, a.apply(this, arguments);
      },
          i = this && this.__rest || function (t, e) {
        var r = {};

        for (var o in t) {
          Object.prototype.hasOwnProperty.call(t, o) && e.indexOf(o) < 0 && (r[o] = t[o]);
        }

        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var n = 0;

          for (o = Object.getOwnPropertySymbols(t); n < o.length; n++) {
            e.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[n]) && (r[o[n]] = t[o[n]]);
          }
        }

        return r;
      },
          u = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var s = r(685),
          p = r(674),
          c = u(r(167)),
          l = r(517),
          f = function (t) {
        function e(e) {
          var r = t.call(this) || this;
          return r._node = c.default.create(e), r._node.defaults.timeout = 6e4, r;
        }

        return n(e, t), e.prototype._handleNodeError = function (t, e) {
          t.name;
          var r = t.message,
              o = i(t, ["name", "message"]),
              n = (0, l.get)(t, "response.data") || r;
          throw new p.NodeError(n, a(a({}, e), o));
        }, e.prototype.nodeGet = function (t, e) {
          var r = this;
          return void 0 === e && (e = {}), this._node.get(t, {
            params: e
          }).then(function (t) {
            return t.data;
          }).catch(function (o) {
            return r._handleNodeError(o, {
              url: t,
              params: e
            });
          });
        }, e.prototype.nodePost = function (t, e) {
          var r = this;
          return this._node.post(t, e).then(function (t) {
            return t.data;
          }).catch(function (o) {
            return r._handleNodeError(o, {
              url: t,
              data: e
            });
          });
        }, e;
      }(s.Provider);

      e.default = f;
    },
    175: function _(t, e, r) {
      var o = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.NodeProvider = void 0;
      var n = o(r(580));
      e.NodeProvider = n.default;
    },
    674: function _(t) {
      t.exports = require("@yaswap/errors");
    },
    685: function _(t) {
      t.exports = require("@yaswap/provider");
    },
    167: function _(t) {
      t.exports = require("axios");
    },
    517: function _(t) {
      t.exports = require("lodash");
    }
  },
      e = {},
      r = function r(o) {
    var n = e[o];
    if (void 0 !== n) return n.exports;
    var a = e[o] = {
      exports: {}
    };
    return t[o].call(a.exports, a, a.exports, r), a.exports;
  }(175);

  module.exports = r;
})();